import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectService } from '../../project/project.service';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-results-sidebar',
  templateUrl: './results-sidebar.component.html',
  styleUrls: [
    './results-sidebar.component.scss',
  ]
})
export class ResultsSidebarComponent extends UserpilotReloader implements OnInit {
  showBaseline = false;
  showSensAnalysis = false;
  showScenarioComp = false;
  showFinancial = true;

  constructor(private router: Router,
              private projectService: ProjectService) {
    super();
  }

  ngOnInit() {
    const url = this.router.url.split('/');
    switch (url[2]) {
      case 'baseline':
        this.showBaseline = true;
        break;
      case 'sensitivity':
        this.showSensAnalysis = true;
        break;
      case 'scenario-comparison':
        this.showScenarioComp = true;
        break;
      default:
        break;
    }
    this.showFinancial = this.projectService.project.projectInfo.useFinancial;
  }

  isBaselineExpanded() {
    return this.showBaseline;
  }

  toggleBaseline() {
    this.showBaseline = !this.showBaseline;
  }

  isSensAnalysisExpanded() {
    return this.showSensAnalysis;
  }

  toggleSensAnalysis() {
    this.showSensAnalysis = !this.showSensAnalysis;
  }

  isScenarioCompExpanded() {
    return this.showScenarioComp;
  }

  toggleScenarioComp() {
    this.showScenarioComp = !this.showScenarioComp;
  }

  isSensitivityAvailable() {
    return this.projectService.project.projectInfo.useFinancial;
  }
}
